export default __webpack_public_path__ + "static/media/tts-new.62caf035.svg";